import styled from "@emotion/styled";
import { Box, ButtonBase } from "@mui/material";

export const CardsContainer = styled.div({
	containerType: "inline-size",
	width: "100%"
});

export const CardsLayout = styled.div<{ cardCount: number }>(({ cardCount }) => ({
	display: "grid",
	gap: 16,
	gridTemplateColumns: "330px",
	justifyContent: "center",
	width: "100%",
	"@container (min-width: 676px)": {
		gridTemplateColumns: "repeat(2, 330px)"
	},
	...(cardCount === 3 && {
		"@container (min-width: 1022px)": {
			gridTemplateColumns: "repeat(3, 330px)"
		}
	}),
	...(cardCount === 4 && {
		"@container (min-width: 1368px)": {
			gridTemplateColumns: "repeat(4, 330px)"
		}
	})
}));

export const CardTop = styled.div({
	alignItems: "center",
	display: "flex",
	flex: 1,
	flexDirection: "column",
	justifyContent: "center",
	minHeight: 0,
	width: "100%"
});

export const CardRoot = styled.section<{ accent: string }>(({ accent }) => ({
	alignItems: "center",
	background: "#fff",
	border: `2px solid ${accent}`,
	boxSizing: "border-box",
	display: "flex",
	flexDirection: "column",
	height: 313,
	padding: "12px",
	width: 330
}));

export const CardIllustration = styled.div<{ color: string }>(({ color }) => ({
	alignItems: "center",
	color,
	display: "flex",
	height: 80,
	justifyContent: "center",
	"& > svg": {
		display: "block",
		height: 70,
		maxWidth: "100%",
		strokeWidth: 1,
		width: "auto"
	},
	"& > img": {
		display: "block",
		height: 80,
		objectFit: "cover",
		width: 130
	}
}));

export const CardTitle = styled.h2<{ color: string }>(({ color }) => ({
	alignItems: "center",
	color,
	display: "flex",
	fontSize: 20,
	fontWeight: 500,
	gap: 6,
	lineHeight: 1.25,
	margin: "0 0 8px"
}));

export const Badge = styled.span<{ color: string }>(({ color }) => ({
	alignItems: "center",
	background: color,
	borderRadius: 10,
	color: "#fff",
	display: "inline-flex",
	fontSize: 12,
	fontWeight: 600,
	height: 20,
	justifyContent: "center",
	minWidth: 20,
	padding: "0 6px"
}));

export const ActionGrid = styled.div({
	background: "#fcfcfc",
	border: "1px solid #e3e3e3",
	display: "grid",
	flex: 1,
	gridTemplateColumns: "repeat(2, 1fr)",
	width: "100%"
});

export const ActionButton = styled(ButtonBase)<{ color: string }>(({ color }) => ({
	alignItems: "center",
	color,
	display: "flex",
	flexDirection: "column",
	fontSize: 14,
	gap: 3,
	justifyContent: "center",
	lineHeight: 1.2,
	minHeight: 66,
	padding: 6,
	textAlign: "center",
	"& svg": {
		fontSize: 24
	},
	"&:focus-visible": {
		outline: `3px solid ${color}`,
		outlineOffset: -3
	},
	"&:hover": {
		background: "rgba(0, 101, 148, 0.07)"
	}
}));

export const CountState = styled.span({
	alignItems: "center",
	display: "flex",
	fontSize: 12,
	gap: 4,
	minHeight: 20,
	"& .MuiButton-root": {
		fontSize: 12,
		lineHeight: 1.2,
		minWidth: 0,
		padding: "1px 4px"
	}
});

export const DialogBody = styled(Box)({
	display: "flex",
	flexDirection: "column",
	gap: 14,
	padding: "4px 24px 16px"
});

export const DialogError = styled.div({
	color: "#d32f2f",
	fontSize: 14
});

export const OrderChoice = styled(ButtonBase)({
	alignItems: "flex-start",
	border: "1px solid #c7c7c7",
	display: "flex",
	flexDirection: "column",
	padding: 10,
	textAlign: "left",
	width: "100%",
	"&:focus-visible": {
		outline: "3px solid #006594"
	}
});
